import { render } from "./PartnerVerifyWildcard.vue?vue&type=template&id=1509b78d&scoped=true"
import script from "./PartnerVerifyWildcard.vue?vue&type=script&lang=js"
export * from "./PartnerVerifyWildcard.vue?vue&type=script&lang=js"

import "./PartnerVerifyWildcard.vue?vue&type=style&index=0&id=1509b78d&scoped=true&lang=sass"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1509b78d"]])

export default __exports__